import { Controller } from "@hotwired/stimulus"

// Keeps a <details> the user opened open across a Turbo morph refresh (the
// server renders it closed, and a morph would copy that over).
//
//   <details data-controller="keep-open" data-action="turbo:before-morph-attribute->keep-open#keep">
export default class extends Controller {
  keep(event) {
    if (event.detail?.attributeName === "open") event.preventDefault()
  }
}
